import { FDealType, FOfferType, getDealTypeFromJsonQuery, getOfferTypeFromJsonQuery } from '@/packages/JsonQuery';
import { isClosed } from '@/packages/MapBanners/browser/utils/banner';

import { EBanners, REALTOR_REPORT_CLOSED_COOKIE_KEY } from '../../../constants/banners';
import { type IMapBannersProps } from '../../../types/props';

/** Проверяет условия показа баннера RealtorReport. Вернет enum, если условия выполняются. */
export const useRealtorReportBanner = ({ userIsAgent, jsonQuery }: IMapBannersProps): EBanners | null => {
  const dealType = getDealTypeFromJsonQuery(jsonQuery);
  const offerType = getOfferTypeFromJsonQuery(jsonQuery);

  const isRent = dealType === FDealType.RentLongterm;
  const isSale = dealType === FDealType.Sale;
  const isValidDealType = isRent || isSale;

  const isFlat = offerType === FOfferType.Flat;

  if (typeof window === 'undefined' || !userIsAgent || !isValidDealType || !isFlat) {
    return null;
  }

  if (!isClosed(REALTOR_REPORT_CLOSED_COOKIE_KEY, EBanners.RealtorReport)) {
    return EBanners.RealtorReport;
  }

  return null;
};
